import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import EducationWorkPrograms from '../../components/educationWorkPrograms/EducationWorkPrograms';
import * as actions from '../../actions/umk';
import { fetchEducationWorkPrograms, fetchCourse, fetchMetaCourse } from '../../actions/educationWorkPrograms';
import { getYears } from '../../actions/schedule';

import * as curriculumDataActions from '../../actions/curriculumData';

const mapStateToProps = ({ umk, educationWorkPrograms, schedule, curriculumData }) => ({
  curriculum: umk.curriculum,
  disciplines: umk.disciplines,
  disciplineRPD: educationWorkPrograms.disciplineRPD,
  discipline: educationWorkPrograms.discipline,
  umk: umk.umkList,
  educationPrograms: educationWorkPrograms.educationPrograms,
  educationYears: schedule.educationYear,

  schoolYears: schedule.studyYear,
  isLoading: educationWorkPrograms.isLoading,

  coursesList: curriculumData.coursesList,
  pagesCount: educationWorkPrograms.pagesCount,
  totalCount: educationWorkPrograms.totalCount,
});

const mapDispatchToProps = dispatch => ({

  fetchCurriculum: (syid) => dispatch(actions.fetchCirriculum(syid)),
  fetchYears: () => dispatch(getYears()),

  fetchDisciplines: curriculumId => dispatch(actions.fetchDisciplines(curriculumId)),

  fetchUmk: (curriculumId, disciplineId) => dispatch(actions.fetchUmk(curriculumId, disciplineId)),
  fetchEducationPrograms: (numberPage, curriculumId, disciplineId, syid, type) => dispatch(fetchEducationWorkPrograms(numberPage, curriculumId, disciplineId, syid, type)),

  // getCourses: () => dispatch(curriculumDataActions.getCurriculumCourses()),
  // fetchCourse: (syid, curriculumId, idmetacourse) => dispatch(fetchCourse(syid, curriculumId, idmetacourse)),
  fetchMetaCourse: (syid, curriculumId, cid) => dispatch(fetchMetaCourse(syid, curriculumId, cid)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EducationWorkPrograms)
);
